import dnseCommon from './common';
import dnseOrder2 from './order2';
import dnsePortfolio from './portfolio';
import dnsePopupOTP from './popupOTP';
import errorCode from './errorcode';
export default {
  dnseCommon,
  dnseOrder2,
  dnsePortfolio,
  dnsePopupOTP,
  errorCode,
};
